import styled from 'styled-components'
import { Profile } from '@styled-icons/icomoon/Profile'
import { ArrowDown as AD } from '@styled-icons/bootstrap/ArrowDown'
import { ArrowUp as AU } from '@styled-icons/bootstrap/ArrowUp'
import { ArrowSort as AS } from '@styled-icons/fluentui-system-filled/ArrowSort'
import { PeopleEdit } from '@styled-icons/fluentui-system-regular/PeopleEdit'
import { Select } from 'antd'
import { BqButton, BqIcon } from '@beeq/react'
import PageActionWrapper from '../PageActionWrapper'

export const UserListWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Title = styled.h4`
  color: var(--bq-endava-grey-800);
  margin: var(--bq-spacing-xl) 0;
  @media screen and (max-width: 1395px) {
    margin: var(--bq-spacing-xs) 0;
  }
`

export const TableWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`

export const DropDownStatus = styled(Select)`
  margin-left: 27px;
`

export const RowsWrapper = styled.div`
  height: 100%;
  overflow-x: auto;
  @media screen and (max-width: 1395px) {
    width: 1083px;
  }
`

export const SpinnerWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding-top: 22px;
  width: 100%;
  @media screen and (max-width: 1395px) {
    width: 1083px;
    padding-top: 0;
  }
  white-space: nowrap;
`

export const TableTitle = styled.p`
  height: ${(props) => props.$height};
  width: ${(props) => props.$width};
  min-width: ${(props) => props.$minWidth || 'initial'};
  display: flex;
  align-items: center;
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'left')};
  font-weight: bold;
  padding-left: ${(props) => (props.$leftPadding ? props.$leftPadding : '1rem')};
  @media screen and (min-width: 1540px) {
    padding-left: ${(props) =>
      props.id === 'coreskill'
        ? '1.5rem'
        : props.id === 'country' || props.id === 'du'
        ? '1.6rem'
        : props.id === 'completation'
        ? '2rem'
        : '1rem'};
  }
`

export const TableTitleBig = styled.p`
  min-width: 210px;
  text-align: center;
  margin-left: auto;
  font-weight: bold;
`

export const FilterProfilesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const FilterExportWrapper = styled(PageActionWrapper)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media screen and (max-width: 1395px) {
    margin-top: 0;
  }
`

export const ExportProfileWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: var(--bq-spacing-l);
`

export const GlobalAdvancedFilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: var(--bq-spacing-xs);
`
export const FilterTagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: var(--bq-spacing-xs);
`
export const FilterTagWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 4px 4px;
`

export const InfoRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0 10px 0;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  white-space: normal;
  border-top: var(--bq-stroke-s, 1px) solid transparent;
  border-bottom: var(--bq-stroke-s, 1px) solid transparent;

  &:hover {
    background-color: color-mix(in srgb, transparent, var(--bq-hover) 5.8%);
  }

  &.active {
    background: var(--bq-ui--brand-alt);
    border-top: var(--bq-stroke-s, 1px) solid var(--bq-stroke--brand);
    border-bottom: var(--bq-stroke-s, 1px) solid var(--bq-stroke--brand);
  }
`
export const NameInfoRowField = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  align-items: center;
  white-space: nowrap;
  // color: var(--bq-brand);
  color: ${(props) => (props.$color ? props.$color : 'var(--bq-brand)')};
`
export const InfoRowField = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minWidth ? props.$minWidth : 'initial')};
  align-items: center;
  white-space: nowrap;
`
export const InfoRowInToolTip = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`
export const InfoRow = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const InfoRowIcons = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  &:hover {
    overflow: visible;
    white-space: normal;
  }
`
export const InfoRowSingleIcon = styled.div`
  display: flex;
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  &:hover {
    overflow: visible;
    white-space: normal;
  }
`

export const EmailInfoRowField = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  white-space: nowrap;
`
export const EmailInfoRow = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-bottom: 0;
`

export const CountryInfoRowField = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  white-space: nowrap;
`
export const CountryInfoRow = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-bottom: 0;
`
export const ProfileIcon = styled(Profile)`
  margin-left: 10px;
  color: #c0c0c0;
  cursor: pointer;
`

export const ArrowDown = styled(AD)`
  cursor: pointer;
`
export const ArrowUp = styled(AU)`
  cursor: pointer;
`
export const ArrowSort = styled(AS)`
  cursor: pointer;
`
export const EditIcon = styled(PeopleEdit)`
  color: #1890ff;
`
export const SortButton = styled(BqButton)`
  --bq-button--small-height: var(--bq-spacing-l);
  top: -4px;

  &::part(button) {
    border: 0;
    width: var(--bq-spacing-m);
  }
`
export const SortIcon = styled(BqIcon)`
  --bq-icon--size: 16px;
`
